import React from 'react';
import CardView from '~/components/cartView';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import Select from '~/components/select';
import Button from '~/components/button';
import * as St from '~/views/Consult/User/Detail/styles';
import { RELATION_TYPES } from '~/models/proposta-contatos-ref';

interface ReferencesSectionProps {
  addReference: any;
  addReferenceII: any;
  handleChangeReference: (e: any) => void;
  handleChangeReferenceII: (e: any) => void;
  handleSelectReference: (value: any, name: string) => void;
  handleSelectReferenceII: (value: any, name: string) => void;
  disabledButtonSave: () => boolean;
  onSave: () => void;
}

const ReferencesSection: React.FC<ReferencesSectionProps> = ({
  addReference,
  addReferenceII,
  handleChangeReference,
  handleChangeReferenceII,
  handleSelectReference,
  handleSelectReferenceII,
  disabledButtonSave,
  onSave,
}) => {
  return (
    <>
      <ContainerFlex marginLeft={26} marginRight={26}>
        <Grid xs={1} lg={2}>
          <ContainerFlex>
            <St.TitleCategory style={{ paddingLeft: '0px' }}>
              Referência I
            </St.TitleCategory>
            <br />
            <ContainerFlex marginRight={20}>
              <Input
                label="Nome completo"
                name="nomeRefe"
                value={addReference?.nomeRefe}
                onChange={handleChangeReference}
              />
              <Input
                label="Telefone"
                name="phoneRefe"
                value={addReference?.phoneRefe?.masked}
                maxLength={15}
                mask={MaskTypes.PHONE}
                onChange={handleChangeReference}
              />
              <Select
                label="Relação com o cliente"
                value={addReference?.relacaoCli}
                name="relacaoCli"
                onChange={(val) => {
                  handleSelectReference(val, 'relacaoCli');
                }}
                options={RELATION_TYPES}
              />
              <Input
                label="Comentário"
                name="comentarioRef"
                value={addReference?.comentarioRef}
                onChange={handleChangeReference}
              />
            </ContainerFlex>
          </ContainerFlex>

          <ContainerFlex>
            <St.TitleCategory style={{ paddingLeft: '5px' }}>
              Referência II
            </St.TitleCategory>
            <br />
            <ContainerFlex marginRight={20}>
              <Input
                label="Nome completo"
                name="nomeRefe"
                value={addReferenceII?.nomeRefe}
                onChange={handleChangeReferenceII}
              />
              <Input
                label="Telefone"
                name="phoneRefe"
                value={addReferenceII?.phoneRefe?.masked}
                maxLength={15}
                mask={MaskTypes.PHONE}
                onChange={handleChangeReferenceII}
              />
              <Select
                label="Relação com o cliente"
                value={addReferenceII?.relacaoCli}
                name="relacaoCli"
                onChange={(val) => {
                  return handleSelectReferenceII(val, 'relacaoCli');
                }}
                options={RELATION_TYPES}
              />
              <Input
                label="Comentário"
                name="comentarioRef"
                value={addReferenceII?.comentarioRef}
                onChange={handleChangeReferenceII}
              />
            </ContainerFlex>
          </ContainerFlex>
        </Grid>
      </ContainerFlex>
      <CardView>
        <ContainerFlex row end padding={24}>
          <Button
            marginLeft={16}
            onClick={onSave}
            disabled={disabledButtonSave()}
          >
            Salvar
          </Button>
        </ContainerFlex>
      </CardView>
    </>
  );
};

export default ReferencesSection;
